import { render, staticRenderFns } from "./ListPickupPoints.vue?vue&type=template&id=b961aa32&"
import script from "./ListPickupPoints.vue?vue&type=script&lang=js&"
export * from "./ListPickupPoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports